import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const maintenancePlanGroupSchema = surrealRecordSchema.extend({
  name: z.string(),
});

export type MaintenancePlanGroup = z.infer<typeof maintenancePlanGroupSchema>;
